import {formatPrice,checkAusbildung} from "./logic";
import {get_anz_kinder, kinder_vorhanden} from "./kinder";
const Saetze = require('./saetze.js');

class Vermoegen {
// TODO Haus+Gründstücke
    /**
     *
     * @param bargeld
     * @param girokonto
     * @param bausparvertrag
     * @param lebensversicherung
     * @param kfz
     * @param riester
     * @param ausbildung
     * @param monate
     * @param kinder_vorh
     * @param anz_kinder
     * @param ue30
     */
    constructor(
                bargeld = 0,
                girokonto = 0,
                bausparvertrag = 0,
                lebensversicherung = 0,
                kfz = 0,
                riester = 0,
                ausbildung = null,
                monate = 12,
                kinder_vorh = false,
                anz_kinder = 0,
                ue30 = false)
    {
        this.bargeld = Number(bargeld);
        this.girokonto = Number(girokonto);
        this.bausparvertrag = Number(bausparvertrag);
        this.lebensversicherung = Number(lebensversicherung);
        this.kfz = Number(kfz);
        this.riester = Number(riester);
        this.ausbildung = ausbildung;
        this.monate = Number(monate);
        this.kinder_vorh = kinder_vorh;
        this.anz_kinder = Number(anz_kinder);
        this.ue30 = ue30;
        this.FREIBETRAG_VERMOEGEN_BAFOEG = Saetze.FREIBETRAG_VERMOEGEN_BAFOEG;
        this.FREIBETRAG_VERMOEGEN_BAFOEGAB30 = Saetze.FREIBETRAG_VERMOEGEN_BAFOEGAB30;
        this.FREIBETRAG_VERMOEGEN_AUFSTIEG = Saetze.FREIBETRAG_VERMOEGEN_AUFSTIEG;
        this.FREIBETRAG_VERMOEGEN_RIESTER = Saetze.FREIBETRAG_VERMOEGEN_RIESTER;
        this.FREIBETRAG_VERMOEGEN_KIND = Saetze.FREIBETRAG_VERMOEGEN_KIND;
    }

    get null() {
        return this.berechneNull();
    }
    /**
     * 0 zurückgeben
     * @returns {string}
     */
    berechneNull() {
        return formatPrice(0);
    }

    get berechnung() {
        return this.berechneVermoegenAbzuege();
    }

    /**
     * Berechne das anzurechnende Vermögen
     * @returns {number}
     */
    berechneVermoegenAbzuege() {
        let summe1 = 0.00;
        let summe2 = 0.00;
        let freibetrag_vermoegen = 0.00;
        summe1 += this.bargeld;
        summe1 += this.girokonto;
        summe1 += this.bausparvertrag;
        summe1 += this.lebensversicherung;
        summe1 += this.kfz;
        //console.log('summe1: '+summe1)
        //console.log('vermoegen1: '+this.ausbildung)
        switch (this.ausbildung) { // Freibetrag holen
            case 'student':
            case 'schuelermit':
            case 'schuelerohne':
            //console.log('ue30: '+this.ue30)
                if(this.ue30){
                    freibetrag_vermoegen = this.FREIBETRAG_VERMOEGEN_BAFOEGAB30
                }else{
                    freibetrag_vermoegen = this.FREIBETRAG_VERMOEGEN_BAFOEG
                }
                break;
            case 'meister':
                freibetrag_vermoegen = this.FREIBETRAG_VERMOEGEN_AUFSTIEG
                break;
            default:
                if(this.ue30){
                    freibetrag_vermoegen = this.FREIBETRAG_VERMOEGEN_BAFOEGAB30
                }else{
                    freibetrag_vermoegen = this.FREIBETRAG_VERMOEGEN_BAFOEG
                }
                break;
        }
        summe1 = (summe1 > freibetrag_vermoegen)?summe1 - freibetrag_vermoegen:0;
        summe2 = (this.riester > this.FREIBETRAG_VERMOEGEN_RIESTER)? this.riester - this.FREIBETRAG_VERMOEGEN_RIESTER : 0;
        let abzuege = (summe1+summe2)
        /**
         * Kinderfreibetrag abziehen
         */
        if(this.kinder_vorh){
            abzuege -= this.anz_kinder*this.FREIBETRAG_VERMOEGEN_KIND
            if(abzuege<0){
                abzuege = 0
            }
        }
        return (abzuege/12)
    }

}

/**
 * Vermögen berechnen oder nullen
 * @param $this
 * @param aus
 */
function vermoegenBerechnen($this, aus = false){
    if(aus) {
        const nu = new Vermoegen();
        $this.el$('results.vermoegen').value = nu.null
        //console.log('Vermögen aus: nullen')
    }else{
        calculateVermoegen($this, 12)
        //console.log('Vermögen an: berechnen')
    }
}

/**
 * Abzüge für das Vermögen berechnen
 * @param $this
 * @param monate
 */
function calculateVermoegen($this, monate = 12){

    //console.log('Vermögen-Arten: '+$this.el$('Vermoegen.art').value)
    // alle ausgewählten Vermögen in ein Array schreiben
    let values = $this.el$('Vermoegen.art').value
    // Vermögensarten berechnen
    let abzuege
    let ue30 = false;
    let riester = 0.00;
    let ausbildung = checkAusbildung($this)
    let werte = [];
    //console.log('vermoegen2: ' + ausbildung)
    switch (ausbildung) {
        case 'meister':
            //console.log('meister vermögen')
            if($this.el$('Vermoegen.grenzemeister').value === 'ja'){
                //console.log('grenze meister ja')
                werte = get_werte($this,values)
            }
            break;
        case 'student':
        case 'schuelermit':
        case 'schuelerohne':
        default:
            //console.log('bafög vermögen')
            if($this.el$('Vermoegen.grenzebafoeg').value === 'ja' || $this.el$('Vermoegen.grenzeu30bafoeg').value === 'ja'){
                //console.log('grenze bafög ja')
                werte = get_werte($this,values)
            }
            break;
    }

    if($this.el$('Vermoegen.ue30verm').value === 'ja'){
        ue30=true;
    }else{
        ue30=false;
    }

    if(values.includes(4)){ // Riester-Versicherung mit anrechnen lassen
        riester = $this.el$('Vermoegen.riester').value;
        //console.log('Riester: '+riester)
    }
    //console.log('Berechnung: '+werte[0]+' '+werte[1]+' '+werte[2]+' '+werte[3]+' '+werte[4]+' '+riester+' '+ausbildung+' '+monate)
    const verm = new Vermoegen(werte[0],werte[1],werte[2],werte[3],werte[4],riester,ausbildung,monate,kinder_vorhanden($this),get_anz_kinder($this),ue30);
    abzuege = verm.berechnung
    //console.log('Vermögen: '+abzuege)
    $this.el$('results.vermoegen').value = formatPrice(abzuege)
}

/**
 * Werte aus den Feldern holen und zurück geben
 * @param $this
 * @param values
 * @returns {number[]}
 */
function get_werte($this, values){
    let bargeld = 0.00;
    let girokonto = 0.00;
    let bausparvertrag = 0.00;
    let lebensversicherung = 0.00;
    let kfz = 0.00;
    for (let wert of values){
        switch(wert) {
            case 0: // Bargeld
                bargeld = $this.el$('Vermoegen.bargeld').value
                //console.log('Bargeld: '+bargeld)
                break;
            case 1: // Girokonto
                girokonto = $this.el$('Vermoegen.girokonto').value;
                //console.log('Girokonto: '+girokonto)
                break;
            case 2: // Bausparvertrag
                bausparvertrag = $this.el$('Vermoegen.bauspar').value;
                //console.log('Bausparvertrag: '+bausparvertrag)
                break;
            case 3: // Lebensversicherung
                lebensversicherung = $this.el$('Vermoegen.lebensv').value;
                //console.log('Lebensversicherung: '+lebensversicherung)
                break;
            case 5: // KFZ
                kfz = $this.el$('Vermoegen.kfz').value;
                //console.log('KFZ: '+kfz)
                break;
            default:
                break;
        }
    }
    return [bargeld,girokonto,bausparvertrag,lebensversicherung,kfz]
}

/**
 * Funktionen exportieren
 */
export {vermoegenBerechnen};
